export default __webpack_public_path__ + "static/partners03-4fb9b895a948bd8ab5033e6ffe3450f4.svg";